import React, { useRef } from 'react';

import { useOutsideClick } from 'utils/custom-hooks';

import './info-modal.scss';

const paymentModels = [
	{
		label: 'CPA+ (Cost Per Acquisition)',
		description: (
			`Brands pay a percent commission on sales you drive. On Narrativ, sales are measured 
			on a post-click, 30-day attribution window and returns are never deducted from your 
			earnings. For example, if you have a 10% commission rate from a brand, and shoppers buy 
			$100 worth of products from your recommendation, that brand will pay you $10 in commissions. `
		),
	},
	{
		label: 'EPC (Earnings Per Click)',
		description: (
			`Brands pay you a flat rate per click you drive to their site, regardless of resulting 
			sales. For example, if the brand agrees to pay you a $0.50 EPC, and you drive 100
			clicks to them, the merchant will pay you $50.`
		),
	},
];

const rates = [
	{
		label: 'Strategic Rates',
		description: (
			`This is a special rate a brand can offer you in the Narrativ platform. 
			This type of rate is usually for events like product launches, sales, and thematic campaigns 
			(e.g. Black Owned Brands, iPhone Launch). View all the products this rate applies to by 
			clicking on the strategy in your dashboard.`
		),
	},
	{
		label: 'Baseline Rates',
		description: (
			`This is a brand’s average rate across the partners they work with on the Narrativ platform.`
		),
	},
];

const InfoModal = ({setDisplayModal, modalType}) => {
	const modal = useRef(false);

	useOutsideClick(modal, () => setDisplayModal(false));

	const modalHeader = modalType === 'payment-models'
		? 'Narrativ Payment Models'
		: 'Narrativ Rates';

	const modalContent = modalType === 'payment-models'
		? paymentModels
		: rates;
	const modalBody = modalContent.map((item, idx) => {
		return (
			<div key={idx}>
				<h2>{item.label}</h2>
				<div>{item.description}</div>
			</div>
		);
	});

	return (
		<div className="info-modal-container">
			<div className="info-modal" ref={(node) => modal.current = node}>
				<h1>{modalHeader}</h1>
				<span className="close-btn" onClick={() => setDisplayModal(false)}>X</span>
				{modalBody}
			</div>
		</div>
	);
};

export default InfoModal;
